import { FaClock, FaChartLine, FaBookOpen, FaMoneyBill, FaHandsHelping, FaArrowUp } from 'react-icons/fa';
import { images } from '../constants'; 


const careerIntro = {
    sub: "Join Our Team",
    heading: "Join the Roofing Installation Team Today",
    description: "At Roofing Installation Services, we're looking for dedicated individuals to become part of our team. Explore exciting career opportunities in roofing installation and maintenance services. Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptatem enim nobis ea quo sint vero laboriosam ex repellendus.",
    points: [
        "Opportunities in Roof Installation",
        "Assist in Roof Repair Operations",
        "Advanced Roofing Training Programs",
        "Roof Inspection and Maintenance",
        "Support in Roofing Safety Measures",
    ],
};

const benefits = [
    {
        id: 1,
        icon: <FaChartLine />,
        title: "Career Advancement",
        description:
            "Explore abundant opportunities for career growth and advancement within the roofing installation and maintenance industry.",
    },
    {
        id: 2,
        icon: <FaBookOpen />,
        title: "Training Programs",
        description:
            "Participate in comprehensive training programs tailored to enhance your skills in roofing installation, repair, and inspection, ensuring proficiency in various roofing techniques and methods.",
    },
    {
        id: 3,
        icon: <FaMoneyBill />,
        title: "Competitive Pay",
        description:
            "Enjoy attractive pay packages and benefits in the roofing services sector, ensuring financial stability and security.",
    },
    {
        id: 4,
        icon: <FaClock />,
        title: "Flexible Hours",
        description:
            "Benefit from flexible working hours designed to accommodate your personal commitments and lifestyle preferences, promoting work-life balance.",
    },
    {
        id: 5,
        icon: <FaHandsHelping />,
        title: "Team Support",
        description:
            "Experience a collaborative and supportive team environment within the roofing industry, fostering camaraderie and mutual growth.",
    },
    {
        id: 6,
        icon: <FaArrowUp />,
        title: "Growth Potential",
        description:
            "Unlock vast opportunities for personal and professional growth, with ample room for advancement and skill development in the dynamic roofing industry landscape.",
    },
];

const positions = [
    {
        id: 1,
        image: images.position1,
        title: 'Roofing Installer',
        details: {
            location: 'Roofing Services, City',
            timing: 'Full Time',
            hours: 'Flexible Shifts',
            experience: 'Minimum 3 Years in Roofing Installation',
            position: 'Multiple Positions Available',
            days: 'Rotational Shifts, Including Weekends',
            salary: '$45K - $60K',
            deadline: 'Apply Now - Open Until Filled',
            number: 'For Assistance: Call 123-456-7890',
        },
        overviews: [
            'We are looking for skilled Roofing Installers to join our team. As a Roofing Installer, you will play a critical role in ensuring the installation and maintenance of high-quality roofing systems. If you have a strong work ethic, attention to detail, and a passion for quality craftsmanship, we encourage you to apply.',
        ],
        responsibilities: [
            'Installing roofing systems, including shingles, tiles, and metal roofs.',
            'Performing roof inspections and assessments.',
            'Ensuring proper ventilation and weatherproofing of roofs.',
            'Working with roofing materials and tools to complete installations efficiently.',
            'Maintaining safety standards on job sites.',
            'Collaborating with other team members to ensure timely project completion.',
        ],
        qualifications: [
            'High school diploma or equivalent.',
            'Minimum 3 years of experience in roofing installation.',
            'Strong physical fitness and ability to work at heights.',
            'Knowledge of roofing materials, tools, and techniques.',
            'Ability to read and interpret technical documents and blueprints.',
            'Excellent communication and teamwork skills.',
        ],
    },
    {
        id: 2,
        image: images.position2,
        title: 'Roofing Repair Technician',
        details: {
            location: 'Roofing Services, City',
            timing: 'Full Time',
            hours: 'Flexible Shifts',
            experience: 'Minimum 2 Years in Roofing Repairs',
            position: 'Multiple Positions Available',
            days: 'Rotational Shifts, Including Weekends',
            salary: '$40K - $55K',
            deadline: 'Apply Now - Open Until Filled',
            number: 'For Assistance: Call 123-456-7890',
        },
        overviews: [
            'We are seeking a reliable Roofing Repair Technician to join our team. As a Roofing Repair Technician, you will be responsible for diagnosing and repairing roofing issues to ensure safety and durability. If you are detail-oriented and have experience in roofing repairs, we would love to have you on our team.',
        ],
        responsibilities: [
            'Identifying roofing issues and providing repair solutions.',
            'Repairing leaks, damaged shingles, and other roof elements.',
            'Performing inspections to determine the extent of damage.',
            'Ensuring quality and safety during all repair tasks.',
            'Collaborating with roofing installers for seamless repairs.',
            'Maintaining tools and equipment in good working condition.',
        ],
        qualifications: [
            'High school diploma or equivalent.',
            'Minimum 2 years of experience in roofing repairs.',
            'Strong knowledge of roofing materials and repair techniques.',
            'Ability to work in various weather conditions and at heights.',
            'Good problem-solving skills and attention to detail.',
            'Team-oriented with excellent communication skills.',
        ],
    },
    {
        id: 3,
        image: images.position3,
        title: 'Roof Inspector',
        details: {
            location: 'Roofing Services, City',
            timing: 'Full Time',
            hours: '9 AM - 5 PM',
            experience: 'Minimum 3 Years in Roof Inspection',
            position: 'Multiple Positions Available',
            days: 'Monday to Friday',
            salary: '$50K - $70K',
            deadline: 'Apply Now - Open Until Filled',
            number: 'For Assistance: Call 123-456-7890',
        },
        overviews: [
            'We are looking for a detail-oriented Roof Inspector to assess the condition of roofs, identify potential issues, and provide accurate inspection reports. The ideal candidate will have expertise in various roofing systems and a keen eye for safety. If you are passionate about ensuring quality and safety, this position is for you.',
        ],
        responsibilities: [
            'Conducting thorough roof inspections to assess condition and damage.',
            'Providing detailed reports on roof health and potential issues.',
            'Recommending necessary repairs or replacements based on inspections.',
            'Collaborating with roofing teams for quality assurance and repairs.',
            'Maintaining inspection records and reports for future reference.',
            'Ensuring compliance with safety regulations during inspections.',
        ],
        qualifications: [
            'High school diploma or equivalent.',
            'Minimum 3 years of experience in roof inspection.',
            'Strong knowledge of roofing materials, systems, and safety standards.',
            'Ability to work at heights and in various weather conditions.',
            'Detail-oriented with strong problem-solving skills.',
            'Excellent communication skills and attention to detail.',
        ],
    },
    {
        id: 4,
        image: images.position4,
        title: 'Gutter Installer',
        details: {
            location: 'Roofing Services, City',
            timing: 'Full Time',
            hours: 'Flexible Shifts',
            experience: 'Minimum 1 Year in Gutter Installation',
            position: 'Multiple Positions Available',
            days: 'Rotational Shifts, Including Weekends',
            salary: '$35K - $45K',
            deadline: 'Apply Now - Open Until Filled',
            number: 'For Inquiries: Call 123-456-7890',
        },
        overviews: [
            'We are looking for a skilled Gutter Installer to join our roofing team. The ideal candidate will have experience in gutter installation, maintenance, and repair, ensuring the proper function and longevity of gutters. If you are detail-oriented and enjoy working outdoors, this is the position for you.',
        ],
        responsibilities: [
            'Installing new gutters and downspouts on residential and commercial buildings.',
            'Inspecting and repairing existing gutters and drainage systems.',
            'Ensuring gutters are properly aligned and securely fastened.',
            'Working with roofing team members to ensure seamless installations.',
            'Maintaining tools and equipment in good working condition.',
            'Adhering to safety regulations and guidelines on all job sites.',
            'Providing excellent customer service and addressing client concerns.',
        ],
        qualifications: [
            'High school diploma or equivalent.',
            'Minimum 1 year of experience in gutter installation.',
            'Familiarity with gutter materials, techniques, and safety practices.',
            'Ability to work in various weather conditions and at heights.',
            'Strong attention to detail and problem-solving skills.',
            'Ability to work effectively as part of a team.',
        ],
    },
    {
        id: 5,
        image: images.position5,
        title: 'Roofing Project Manager',
        details: {
            location: 'Roofing Services, City',
            timing: 'Full Time',
            hours: 'Monday to Friday, 9 AM - 6 PM',
            experience: 'Minimum 5 Years in Roofing Project Management',
            position: 'Multiple Positions Available',
            days: 'Occasional Weekend Work',
            salary: '$70K - $90K',
            deadline: 'Apply Now - Open Until Filled',
            number: 'For Project Inquiries: Call 123-456-7890',
        },
        overviews: [
            'We are seeking an experienced Roofing Project Manager to oversee and coordinate roofing projects from start to finish. The ideal candidate will have a background in project management within the roofing industry and possess excellent leadership and organizational skills. If you’re ready to take on challenging projects and lead a team to success, we want you to join us.',
        ],
        responsibilities: [
            'Managing roofing projects from initial planning through completion.',
            'Coordinating with clients, contractors, and roofing teams.',
            'Ensuring projects are completed on time and within budget.',
            'Managing project schedules, resources, and subcontractors.',
            'Monitoring quality control and ensuring safety compliance on job sites.',
            'Preparing and submitting project reports to senior management and clients.',
            'Managing client communications and expectations throughout the project.',
            'Resolving project issues and mitigating risks as they arise.',
        ],
        qualifications: [
            'Bachelor’s degree in Construction Management or related field.',
            'Minimum 5 years of experience in roofing project management.',
            'Strong leadership, communication, and problem-solving skills.',
            'Ability to manage multiple projects simultaneously.',
            'Proficiency in project management software and tools.',
            'Knowledge of roofing materials, techniques, and safety regulations.',
            'Ability to work under pressure and meet deadlines.',
        ],
    }

];

export { positions, benefits, careerIntro };